













































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TextInput, Uploader } from '@/components';
import PickerInput from './components/PickerInput.vue';
import Picker from './components/Picker.vue';
import { ZxEditor } from 'zx-editor';
import { Button, Dialog, Toast, Popup } from 'vant';
import { save } from '@/api/api';
import { bookNameList, getSchools } from './api/index';
import { isWeiXin } from '@/common/ts/common';
import * as config from './config';
import { appShare, wxShareInfo } from '@/common/ts/common';

Vue.use(Toast)
  .use(Popup)
  .use(Dialog)
  .use(Button);
@Component({
  components: {
    TextInput,
    Uploader,
    PickerInput,
    Picker,
  },
})
export default class Uploading extends Vue {
  options = config.OPTHINES;
  pointOut = false;
  schoolType = false;
  noButton = true;
  overlay = true;
  gradePickerData = ['初一', '初二', '初三', '高一', '高二', '高三'];
  bookPickerData: any[] = [];
  schoolList: any[] = [];
  bookIdArr: any[] = [];
  objItem: any;
  zxEditor: any;
  postContentHeight: any;
  // 需要传的参数
  bookId?: number; // 书籍ID
  phone?: string = ''; // 电话
  grade?: string = ''; // 年级
  title?: string = ''; // 作者名字
  school?: string = ''; // 学校
  className?: string = ''; // 班级
  subtitle?: string = ''; // 作文名称
  content?: string = ''; // 作文内容
  @Watch('school')
  onSchoolValueChanged(newVal: any, val: any) {
    if (newVal) {
      this.fetchSchoolData(newVal);
    }
  }
  mounted() {
    this.zxEditor = new ZxEditor('#editorContainer', {
      autoSave: 0,
      // // 自定义粘贴处理
      // customPasteHandler: true,
      placeholder: '请输入内容',
      showToolbar: false,
      fixed: false,
    });
    console.log('实例化 ZxEditor', this.zxEditor);
    // this.zxEditor.on('paste', function(e: any) {
    //   console.log('paste', e);
    // });
    // window.addEventListener('paste', this.contentPaste);
    setTimeout(() => {
      const editorContainer = document.querySelector(
        '.zxeditor-content-wrapper',
      ) as HTMLElement;
      editorContainer.style.cssText = `
      padding: 0 15px;min-height: 200px; border: 0.04rem dashed #f4b370;border-radius: 0.2rem;margin-top: 0.8rem;font-size: 0.56rem;`;
    }, 20);
  }
  // contentPaste(e) {
  //   this.emit('paste', e, this);
  //   if (!options.customPasteHandler) {
  //     e.preventDefault();
  //     getPasteText(e).then((str) => {
  //       // 添加至焦点处
  //       this.insertElm(util.removeHtmlTags(str));
  //     });
  //   }
  // }
  created() {
    // 登录成功后回调
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    // 分享
    appShare({
      title: '《名师•名著•创新写作》',
      url: window.location.href,
      subtitle: '《名师•名著•创新写作》',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '《名师•名著•创新写作》',
      subtitle: '《名师•名著•创新写作》',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
    if (!window.udid) {
      // if (isWeiXin()) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行上传作品',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        // closeOnClickOverlay: false,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    } else {
      Dialog({ message: '复制粘贴的作文，请手动换行。' });
      if (window.gettoken() === '' || window.gettoken() === 'null') {
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
      }
    }
    bookNameList().then((res: any) => this.successBookData(res));
  }
  successBookData(res: any) {
    // this.bookPickerData = Object.entries(res.data);
    for (const bookItem of Object.entries(res.data)) {
      const objItem = {};
      (objItem as any).id = bookItem[0];
      (objItem as any).value = bookItem[1];
      this.bookPickerData.push(objItem);
    }
  }
  successAreasData(res: any) {
    this.bookPickerData = Object.values(res.data);
  }
  fetchBookData(e: string, index: number) {
    this.bookId = index;
    console.log('this.bookId', this.bookId);
  }
  fetchGradeData(e: string, index: number) {
    this.grade = e;
  }
  fetchSchoolData(value: any) {
    this.schoolType = true;
    getSchools(value).then((res: any) => this.successSchoolData(res));
  }
  successSchoolData(res: any) {
    this.schoolList = res.data.map((schoolData: any) => schoolData.name);
    // console.log('res', res.data.map(schoolData => schoolData.name),this.schoolList);
  }
  chooseSchool(index: number, school: string) {
    console.log('school', school);
    this.school = school;
    this.schoolType = false;
  }
  enterSave() {
    // 报名开放
    if (!window.udid) {
      // if (isWeiXin()) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行上传作品',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        overlay: true,
        closeOnClickOverlay: false,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    } else {
      if (window.gettoken() !== '' && window.gettoken() !== 'null') {
        const plainContent = this.zxEditor.getContent();
        if (!this.title) {
          Toast.fail('请填写姓名');
          return false;
        }
        if (!this.phone) {
          Toast.fail('请填写联系电话');
          return false;
        } else {
          const mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(199[0-9]{8})$/;
          const tell = /^0\d{2,3}-?\d{7,8}$/;
          if (!mobile.test(this.phone) && !tell.test(this.phone)) {
            Toast.fail('请输入正确联系方式');
            return false;
          }
        }
        if (!this.school) {
          Toast.fail('请填写学校');
          return false;
        }
        if (!this.grade) {
          Toast.fail('请选择年级');
          return false;
        }
        if (!this.className) {
          Toast.fail('请输入班级');
          return false;
        }
        if (!this.bookId) {
          Toast.fail('请选择阅读名著');
          return false;
        }
        if (!this.subtitle) {
          Toast.fail('请填写作文题目');
          return false;
        }
        if (plainContent.length <= 11) {
          Toast.fail('请填写作文内容');
          return false;
        }
        const richContent = this.zxEditor.getContent().replace(/\n/g, '<br />');
        // 发送表单数据
        console.log(richContent);
        save(this.options.voteName, {
          udid: window.udid,
          appkey: window.appkey,
          title: this.title,
          phone: this.phone,
          school: this.school,
          grade: this.grade,
          class: this.className,
          book_id: this.bookId,
          subtitle: this.subtitle,
          content: richContent,
        }).then((res: any) => this.successSave(res));
      } else {
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
      }
      setTimeout(() => {
        this.zxEditor.stopAutoSave();
        this.zxEditor.removeSave();
        this.zxEditor.setContent('');
      }, 1000);
    }
  }
  successSave(res: any) {
    if (res.code === 101) {
      Toast.fail('信息填写不全！');
    } else if (res.code === 200) {
      Toast.success('提交成功，请等待审核！');
      this.noButton = false;
      setTimeout(() => {
        this.$router.go(0);
      }, 3000);
    } else if (res.code === 203) {
      Toast.fail('请登录后再访问！');
    } else {
      Toast('未知错误请联系后台');
    }
  }
}
